import { SoundbarIcon } from './SoundbarIcon';

/**
 * author: GreenTurtwig
 * id 1A5FBE33-5A69-4ED4-8A33-416EFA9B24CD
 * name soundbar
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/soundbar.svg
 * tags
 * - Home Automation 
 */
export const SpeakerBarIcon = SoundbarIcon;
export default SpeakerBarIcon